import { create } from "zustand";

const qcAtkCityIdsStore = create((set, get) => ({
  cityIds: {}, // Lưu trữ tất cả các player và config của họ
  setCityId: (playerId, newCityIds) => {
    if (!(newCityIds instanceof Array)) return;
    const isDifferent = (get().cityIds[playerId] instanceof Array)
      && newCityIds.length == get().cityIds[playerId].length
      && newCityIds.some((value, index) => value === get().cityIds[playerId][index])
    if (isDifferent) {
      return;
    }
    set((state) => ({
      cityIds: {
        ...state.cityIds,
        [playerId]: [...newCityIds]
      }
    }))
  }
}));

export default qcAtkCityIdsStore;
